import styled from '@emotion/styled';
import {
  FixedValue,
  MultiLineTextValue,
  PositiveIntegerValue,
  SingleLineTextValue,
} from '@kaizenplatform/hugot-entity';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';

import { DynamicSchemaDefinitionFieldInterface } from '../../../../../generated/graphql';
import _AnchorTypography from '../../../primitive/AnchorTypography';
import LfToBr from '../../../primitive/LfToBr';
import Linkify from '../../../primitive/Linkify';
import Base from './Base';

interface Props {
  field: Pick<DynamicSchemaDefinitionFieldInterface, 'label'>;
  value: SingleLineTextValue | MultiLineTextValue | PositiveIntegerValue | FixedValue;
  className?: string;
}

const AsPlainText = ({ field, value, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Base field={field} className={className}>
      <Value>
        <LfToBr text={`${value}`}>
          {(line, key) => (
            <Linkify text={line} key={key}>
              {(url, key) => (
                <AnchorTypography href={url} withNewTab key={key}>
                  {url}
                </AnchorTypography>
              )}
            </Linkify>
          )}
        </LfToBr>
      </Value>
    </Base>
  );
};

const Value = styled(Typography)({
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
});

const AnchorTypography = styled(_AnchorTypography)({ display: 'inline' });

export default AsPlainText;
